import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useAuthUser } from "../components/dashboard/hooks/useAuthUser";
import type { AccountDetails } from "../components/dashboard/store/AuthContext";
import "./ProfilePage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { ModalContext } from "../components/dashboard/store/ModalContext";
import UpdateProfileForm from "../components/UpdateProfileForm";
import LoadingSpinner from "../components/LoadingSpinner";

function getPersonalDisplayName(d: AccountDetails) {
  const parts = [d.firstName ?? ""];
  if (d.secondName && d.secondName.trim() !== "")
    parts.push(d.secondName.trim());
  parts.push(d.lastName ?? "");
  return parts.join(" ").trim();
}

const ProfilePage: React.FC = () => {
  const { openModal } = useContext(ModalContext);
  const {
    logout,
    details,
    detailsLoading,
    detailsError,
    isBusiness,
    hasCSASubscription,
    isAuthenticated,
    isSocial,
    token,
  } = useAuthUser();

  function handleEdit() {
    openModal({
      title: "Update My Info",
      body: <UpdateProfileForm />,
      showCloseButton: true,
    });
  }

  if (!token) {
    return (
      <div className="alert alert-danger">
        You are not logged in. <Link to="/login">login</Link>
      </div>
    );
  }

  if (detailsLoading || (!details && !detailsError)) {
    return <LoadingSpinner className="loading-spinner-container--fullscreen" />;
  }

  if (detailsError || !isAuthenticated || !details) {
    return (
      <div className="alert alert-danger">
        Could not load your profile. <Link to="/login">login</Link>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-wrapper content-container">
        <div className="wrapper-card green">
          <div className="info-card profile-info">
            <button className="btn profile-btn-fixed" onClick={handleEdit}>
              <FontAwesomeIcon icon={faPen} style={{ color: "#ffffff" }} />
            </button>
            <h1>My Profile</h1>
            <p>
              <span className="bold">{isBusiness ? "Company:" : "Name:"}</span>{" "}
              {isBusiness
                ? details.companyName || "—"
                : getPersonalDisplayName(details) || "—"}
            </p>
            <p>
              <span className="bold">Phone Number:</span>{" "}
              {details.phoneNumber || "No phone number registered"}
            </p>
            <p>
              <span className="bold">Email:</span> {details.email}
            </p>
            <div className="profile-info-btns">
              {isSocial && !hasCSASubscription ? null : (
                <Link to="/dashboard" className="btn dashboard-shortcut ">
                  {isBusiness
                    ? "My Orders"
                    : isSocial && hasCSASubscription
                      ? "My Subscription"
                      : "Go To Dashboard"}
                </Link>
              )}
              <button className="btn" onClick={logout}>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
